/* js/app.js — Mobile drawer helper v15 + CSP addEventListener */
(() => {
  'use strict';
  const drawer = document.getElementById('mobileDrawer');
  if (!drawer) return;
  const overlay = document.getElementById('mobileOverlay');

  function closeMobileMenu() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function toggleMobileMenu() {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('open');
    overlay.classList.toggle('open');
    document.body.style.overflow = drawer.classList.contains('open') ? 'hidden' : '';
  }

  // CSP: addEventListener вместо inline onclick
  if (overlay) overlay.addEventListener('click', closeMobileMenu);
  var closeBtn = document.getElementById('mdCloseBtn');
  if (closeBtn) closeBtn.addEventListener('click', closeMobileMenu);
  drawer.querySelectorAll('.md-link').forEach(function(link) {
    link.addEventListener('click', closeMobileMenu);
  });

  window.toggleMobileMenu = toggleMobileMenu;
  window.closeMobileMenu = closeMobileMenu;
})();

// Floating contacts yield to page controls and captions instead of covering them.
(function () {
  'use strict';
  if (!document.querySelectorAll || !window.requestAnimationFrame) return;
  var scheduled = false;
  var candidates = [];
  var textNodes = [];
  var dirty = true;
  var floaterSelector = '.messenger-widgets, .ai-fab, .scroll-to-top';
  var contentSelector = 'a,button,input,select,textarea,summary,label,[role="button"]';

  function intersects(a, b) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  function visibleBox(el) {
    var box = el.getBoundingClientRect();
    if (!box.width || !box.height || box.bottom <= 0 || box.top >= window.innerHeight) return null;
    if (el.checkVisibility && !el.checkVisibility({checkVisibilityCSS: true, checkOpacity: true})) return null;
    return box;
  }

  function update() {
    scheduled = false;
    var floaters = document.querySelectorAll(floaterSelector);
    if (!floaters.length) return;
    if (dirty) {
      // ⛔ СКРЫТЫЕ ВЕТКИ НЕ ОБХОДИМ (проверка 25.09.2026, P1-3). Прежде собирались ВСЕ
      // ссылки и ВСЕ текстовые узлы документа — и на каждое изменение DOM, и на каждый
      // кадр прокрутки. На студиях Самолёта-6 это 57 тысяч узлов скрытого списка лотов:
      // открытие окна планировки и подъём к генплану занимали главный поток телефона
      // на 2–3 секунды. Ветка без отрисовки (display:none) пропускается целиком;
      // display:contents — не прячет детей, в неё заходим. Браузер без checkVisibility
      // (старый) — обходим всё, как раньше.
      var NF = window.NodeFilter;
      var hidden = function (el) {
        return typeof el.checkVisibility === 'function' && !el.checkVisibility()
          && window.getComputedStyle(el).display !== 'contents';
      };
      candidates = Array.prototype.filter.call(document.querySelectorAll(contentSelector), function (el) { return !hidden(el); });
      textNodes = [];
      var walker = document.createTreeWalker(document.body, NF.SHOW_ELEMENT | NF.SHOW_TEXT, {
        acceptNode: function (node) {
          if (node.nodeType === 3) return NF.FILTER_ACCEPT;
          if (/^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/.test(node.tagName) || hidden(node)) return NF.FILTER_REJECT;
          return NF.FILTER_SKIP;
        }
      });
      var node;
      while ((node = walker.nextNode())) {
        if (/\S/.test(node.nodeValue) && node.parentElement
          && !node.parentElement.closest(floaterSelector + ', #aiW')) textNodes.push(node);
      }
      dirty = false;
    }
    var boxes = [];
    var textRange = document.createRange();
    candidates.forEach(function (el) {
      if (el.closest(floaterSelector + ', #aiW')) return;
      var box = visibleBox(el);
      if (box) boxes.push(box);
    });
    textNodes.forEach(function (node) {
      if (!node.parentElement || !visibleBox(node.parentElement)) return;
      // Measure the actual words, including captions rendered in div/span nodes.
      textRange.selectNodeContents(node);
      Array.prototype.forEach.call(textRange.getClientRects(), function (rect) {
        if (rect.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight) boxes.push(rect);
      });
    });
    floaters.forEach(function (el) {
      var box = el.getBoundingClientRect();
      var yielding = !el.classList.contains('open') && !el.contains(document.activeElement)
        && boxes.some(function (content) { return intersects(box, content); });
      el.classList.toggle('widget-yielding', yielding);
      el.inert = yielding;
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  // Скрытые ветки не собираются (см. update), поэтому их показ — тоже повод пересобрать
  // список: раскрытие <details>, снятие hidden, смена класса (окна открываются классом).
  document.addEventListener('toggle', function () { dirty = true; schedule(); }, true);
  document.addEventListener('transitionend', schedule);
  document.addEventListener('focusout', schedule);
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function () { dirty = true; schedule(); })
      .observe(document.body, {childList: true, characterData: true, subtree: true,
        attributes: true, attributeFilter: ['class', 'hidden', 'open']});
  }
  schedule();
})();
